import { api, BASE, refreshSession, setAccessToken } from "./client.js";
import type { Principal, Session } from "../types/api.js";

export async function login(email: string, password: string): Promise<Session> {
  // Goes through fetch directly rather than the shared client: a sign-in must never trigger the
  // refresh-and-retry path, and a 401 here means "wrong details", not "session expired".
  const res = await fetch(`${BASE}/auth/login`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as {
      error?: { message?: string; correlationId?: string };
    };
    const message =
      res.status === 429
        ? "Too many sign-in attempts. Wait a few minutes and try again."
        : (body.error?.message ?? "Those sign-in details were not accepted.");
    throw new Error(message);
  }

  const session = (await res.json()) as Session;
  setAccessToken(session.accessToken);
  return session;
}

export async function logout(): Promise<void> {
  await fetch(`${BASE}/auth/logout`, { method: "POST", credentials: "include" }).catch(() => {
    // A failed sign-out must still clear the client. The refresh token expires on its own.
  });
  setAccessToken(null);
}

export const restoreSession = refreshSession;

export const me = () => api.get<Principal>("/auth/me");
